// Messages for portal/Notifications (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.notifications.title': 'Notifications — Portal',
}

export const zhTW = {
  'portal.notifications.title': '通知 — 客戶入口',
}
